import Template from "../Template";

function TermsAndConditions() {
  return (
    <Template/>
  );
}

export default TermsAndConditions;
